<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M0.9316406250000001,13.647041036224365C0.9316406250000001,14.164741036224365,1.355169625,14.588241036224366,1.872816625,14.588241036224366C1.872816625,14.588241036224366,15.049240625,14.588241036224366,15.049240625,14.588241036224366C15.566940625,14.588241036224366,15.990440625,14.164741036224365,15.990440625,13.647041036224365C15.990440625,13.647041036224365,15.990440625,7.058821036224365,15.990440625,7.058821036224365C15.990440625,7.058821036224365,0.9316406250000001,7.058821036224365,0.9316406250000001,7.058821036224365C0.9316406249999999,7.058821036224365,0.9316406250000001,13.647041036224365,0.9316406250000001,13.647041036224365C0.9316406250000001,13.647041036224365,0.9316406250000001,13.647041036224365,0.9316406250000001,13.647041036224365ZM15.049240625,4.235291036224365C15.049240625,4.235291036224365,7.915170625,4.235291036224365,7.915170625,4.235291036224365C7.915170625,4.235291036224365,6.305760625,2.6352940362243653,6.305760625,2.6352940362243653C6.136350625,2.456470036224365,5.901050625,2.3529410362243652,5.637520625,2.3529410362243652C5.637520625,2.3529410362243652,1.872816625,2.3529410362243652,1.872816625,2.3529410362243652C1.355169625,2.3529410362243652,0.9316406250000001,2.776470036224365,0.9316406250000001,3.2941170362243652C0.9316406250000001,3.2941170362243652,0.9316406250000001,6.117651036224365,0.9316406250000001,6.117651036224365C0.9316406250000001,6.117651036224365,15.990440625,6.117651036224365,15.990440625,6.117651036224365C15.990440625,6.117651036224365,15.990440625,5.176471036224365,15.990440625,5.176471036224365C15.990440625,4.658821036224365,15.566940625,4.235291036224365,15.049240625,4.235291036224365C15.049240625,4.235291036224365,15.049240625,4.235291036224365,15.049240625,4.235291036224365Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'FolderClose',
} as DefineComponent
</script>
